'use client';
import { Disclosure } from '@headlessui/react';
import { ButtonPrimary } from '@modules/common/components/form/buttons/button-primary';
import { useRouter } from 'next/navigation';

export const GiftCardFAQs = () => {
  const router = useRouter();

  return (
    <div className="product-faqs-list">
      <Disclosure>
        {({ open }) => (
          <div className="product-faqs-list-tab">
            <Disclosure.Button className={`flex items-center justify-between w-full py-0 text-left`}>
              <span className="product-faqs-list-title">How do I send a gift card?</span>
              <span
                className={`min-w-[17px] flex-none ml-2 transform transition-transform duration-200 ${
                  open ? 'rotate-90' : ''
                }`}
              >
                <img src="/arrow.svg" alt="Toggle" />
              </span>
            </Disclosure.Button>
            <Disclosure.Panel className="pt-2">
              Sending a gift card is easy! Simply choose a local restaurant, spa, or salon, select the amount, and send
              it via text or email. You can also print the card and give it in person. It’s fast, convenient, and the
              recipient gets it instantly!
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
      <Disclosure>
        {({ open }) => (
          <div className="product-faqs-list-tab">
            <Disclosure.Button className={`flex items-center justify-between w-full py-0 text-left`}>
              <span className="product-faqs-list-title">How will my recipient receive their gift card?</span>
              <span
                className={`min-w-[17px] flex-none ml-2 transform transition-transform duration-200 ${
                  open ? 'rotate-90' : ''
                }`}
              >
                <img src="/arrow.svg" alt="Toggle" />
              </span>
            </Disclosure.Button>
            <Disclosure.Panel className="pt-2">
              Once you purchase a gift card, the recipient will receive it within minutes via text or email. You can
              also choose the option to print it at home and hand-deliver it. If there are any delays, the gift card
              should be delivered within 24 hours.
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
      <Disclosure>
        {({ open }) => (
          <div className="product-faqs-list-tab">
            <Disclosure.Button className={`flex items-center justify-between w-full py-0 text-left`}>
              <span className="product-faqs-list-title">How do I use my gift card at a local merchant?</span>
              <span
                className={`min-w-[17px] flex-none ml-2 transform transition-transform duration-200 ${
                  open ? 'rotate-90' : ''
                }`}
              >
                <img src="/arrow.svg" alt="Toggle" />
              </span>
            </Disclosure.Button>
            <Disclosure.Panel className="pt-2">
              You can use your Gift Card Market card just like a regular prepaid Mastercard. Either add it to your Apple
              Wallet or Google Pay to use it digitally, or manually enter the 16-digit number at checkout.
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
      <div className="flex items-center justify-center mt-5">
        <ButtonPrimary type="button" onClick={() => router.push(`/faqs`)} size="medium" active={true}>
          More FAQs
        </ButtonPrimary>
      </div>
    </div>
  );
};
